import { Validator } from 'vee-validate'
import VehRegNo from './vehRegNo'

export default function install() {
  Validator.extend('veh_reg_no', VehRegNo)
}
